export default {
      id: "row-in-cell-usage",
      viewBox: "0 0 36 36",
      url: "assets/" + "sprite.svg#row-in-cell-usage",
      toString: function () {
        return this.url;
      }
    }